import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
  selector: 'app-auth-callback',
  standalone: true,
  imports: [],
  template: `<div class="loading-container">
    @if (!error) {
      <p>Authentifizierung wird abgeschlossen...</p>
    }
    @if (error) {
      <div class="error-message">
        <h3>Authentifizierung fehlgeschlagen</h3>
        <p>{{ error }}</p>
        <p class="redirect-message">Weiterleitung zur Anmeldeseite in 3 Sekunden...</p>
      </div>
    }
  </div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .loading-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      font-size: 1.2rem;
      padding: 20px;
      text-align: center;
    }
    .error-message {
      color: #dc2626;
      margin-top: 20px;
      max-width: 500px;
    }
    .error-message h3 {
      color: #dc2626;
      margin-bottom: 16px;
      font-size: 1.5rem;
    }
    .error-message p {
      margin-bottom: 12px;
      line-height: 1.5;
    }
    .redirect-message {
      color: #6b7280;
      font-size: 0.9rem;
      font-style: italic;
    }
  `]
})
export class AuthCallbackComponent implements OnInit {
  error: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Extract parameters from URL
    this.route.queryParamMap.subscribe(params => {
      const error = params.get('error');
      const errorMessage = params.get('message');
      const token = params.get('token');
      
      // Handle error cases first (Apple OAuth failures)
      if (error) {
        this.error = errorMessage || this.getErrorMessage(error);
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 3000);
        return;
      }
      
      // Handle success case
      if (!token) {
        this.error = 'Kein Authentifizierungstoken erhalten';
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 3000);
        return;
      }

      // Exchange token for auth credentials
      this.authService.exchangeOneTimeToken(token).subscribe({
        next: (user) => {
          console.log('Successfully authenticated');
          // Send the user back where they started before the OAuth redirect
          // (persisted by AuthService.loginWithGoogle/loginWithApple), else /profile.
          this.router.navigateByUrl(this.authService.consumeReturnUrl());
        },
        error: (err: HttpErrorResponse) => {
          console.error('Auth callback error:', err);
          
          if (err.status === 0) {
            this.error = 'Verbindung zum Authentifizierungsserver nicht möglich. Möglicherweise ist ein CORS-Fehler aufgetreten.';
          } else {
            this.error = err.error?.message || 'Authentifizierung fehlgeschlagen';
          }
          
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 3000);
        }
      });
    });
  }

  private getErrorMessage(errorCode: string): string {
    switch (errorCode) {
      case 'invalid_state':
        return 'Ungültiger State-Parameter – bitte versuchen Sie es erneut';
      case 'apple_auth_failed':
        return 'Apple-Authentifizierung fehlgeschlagen';
      case 'server_error':
        return 'Beim Anmelden ist ein unerwarteter Fehler aufgetreten';
      default:
        return 'Authentifizierung fehlgeschlagen – bitte versuchen Sie es erneut';
    }
  }
}